import ActionsForm from '@/shared/mixins/actionsForm'
export default {
  mixins: [ActionsForm],
  props: ['despesasid'],
  data () {
    return {
      headTable: ['Data do Gasto', 'Categoria', 'Subcategoria', 'Quantidade', 'Funcionário Vinculados', 'Valor']
    }
  },
  mounted () {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tableCreditUpdate/tableCreditUpdate.js